import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './CardTitle.scss';
import KeyboardArrowDownIcon from '../../Icons/KeyboardArrowDownIcon';
import { getMergedClassNames } from '../../../utils/HTMLUtils';

const rootClassName = styles.rootClassName;

class CardTitle extends Component {
  getStyleClassName = () => {
    return this.props.withStyle
      ? ' MuiTypography-root MuiCardHeader-title MuiTypography-h5 MuiTypography-displayBlock'
      : '';
  };

  render() {
    return (
      <div
        className={getMergedClassNames([
          rootClassName,
          this.props.className || '',
          typeof this.props.onClick === 'function'
            ? rootClassName + '-without-button'
            : '',
        ])}
      >
        <span
          className={getMergedClassNames([
            rootClassName + '-title',
            this.getStyleClassName(),
          ])}
        >
          {this.props.children}
        </span>
        {typeof this.props.onClick === 'function' ? (
          <button
            onClick={this.props.onClick}
            className={getMergedClassNames([
              rootClassName + '-title-button',
              this.getStyleClassName(),
            ])}
          >
            <KeyboardArrowDownIcon className={rootClassName + '-icon-button'} />
            {this.props.children}
          </button>
        ) : null}
      </div>
    );
  }
}

CardTitle.propTypes = {
  onClick: PropTypes.func,
  withStyle: PropTypes.bool,
};

export default CardTitle;
